import { render, staticRenderFns } from "./DeleteChildForPremiumMember.vue?vue&type=template&id=57cc50e6&scoped=true&"
import script from "./DeleteChildForPremiumMember.vue?vue&type=script&lang=js&"
export * from "./DeleteChildForPremiumMember.vue?vue&type=script&lang=js&"
import style0 from "./DeleteChildForPremiumMember.vue?vue&type=style&index=0&id=57cc50e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc50e6",
  null
  
)

export default component.exports